import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      setDone(true);
    } catch (err) {
      setError(err.userMessage || 'Error al enviar el email. Intentá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Paper sx={{ maxWidth: 400, width: '100%', p: 4, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={700} mb={0.5}>Recuperar contraseña</Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Ingresá tu email y te enviaremos un link para restablecer tu contraseña.
        </Typography>

        {done ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            Si el email está registrado, recibirás un link para restablecer tu contraseña. Revisá también tu carpeta de spam.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField
              fullWidth label="Email" type="email" required
              value={email} onChange={e => setEmail(e.target.value)}
              sx={{ mb: 2 }} size="small"
              error={!!error}
            />
            <Button
              fullWidth type="submit" variant="contained"
              disabled={loading || !email}
              sx={{ mb: 2 }}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Enviar link'}
            </Button>
          </form>
        )}

        <Box sx={{ textAlign: 'center' }}>
          <Link to="/" style={{ fontSize: 13, color: '#1565c0' }}>← Volver al login</Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
